const messages = {
  title: '¿Quieres agregar algo más a tu compra?',
  price: 'Precio',
}

export default messages
